import * as React from 'react';

// Utils
import useBreakpoints from '@toolkit/util/useBreakpoints';
import { useDispatch } from 'react-redux';

// Actions, Models & Interfaces
import { setUiMobileFilterOverlay, setUiMobileNoScrolling } from '@pod/ui/actions';

// Components
import Navbar from './Navbar';
import useClickOutside from '@toolkit/util/useClickOutside';

type Props = React.PropsWithChildren & {
  isOpen: boolean;
};

const Sidebar: React.FC<Props> = (props) => {
  const dispatch = useDispatch();
  const { isLg } = useBreakpoints();
  const { isOpen, children } = props;

  const outsideRef = useClickOutside(() => closeMobileFilterOverlay());

  const closeMobileFilterOverlay = () => {
    dispatch(setUiMobileFilterOverlay(false));
    dispatch(setUiMobileNoScrolling(false));
  };

  return (
    <aside className={`sidebar sidebar-trip ${isOpen ? 'is--open' : ''}`}>
      <div className="sidebar-wrapper" ref={outsideRef}>
        {isLg && (
          <Navbar
            showBackButton={false}
            actionRight={() => closeMobileFilterOverlay()}
            iconRight="icon-close2"></Navbar>
        )}
        {children}
      </div>
    </aside>
  );
};

export default Sidebar;
